import { CancelablePromise, PrintExampleDto } from '@/api-sdk';
import { createContext } from '@lit/context';

export type UploadServiceContext =
  | CancelablePromise<string>
  | CancelablePromise<PrintExampleDto>
  | undefined;

export const uploadService =
  createContext<UploadServiceContext>('upload-service');
